// src/utils/posthog.ts
import posthog from "posthog-js";

// Initialize only in production
if (import.meta.env.PROD) {
  posthog.init("phc_uDCyUfCGFQM9NInGxeZOLJNPxOBsTqyffdVvGcBzqBN", {
    api_host: "https://app.posthog.com", // Change for self-hosting
    autocapture: true,
  });
}

export default posthog;
